import { useRef } from 'react';
import { useScaleCanvas } from '../use-scale-canvas';
import certificate from './ExperienceHopeSelectionImages/certificatevisual.svg';
import fileUploadCard from './ExperienceHopeSelectionImages/filuploadcard.svg';
import hero from './ExperienceHopeSelectionImages/zoomimage.png';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const ExperienceHopeShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H);

  return (
    <section
      ref={sectionRef}
      className='relative flex h-full w-full items-center justify-center overflow-hidden bg-warning-50'
    >
      <div style={wrapperStyle}>
        <div style={canvasStyle}>
          <img
            src={hero}
            alt=''
            className='absolute rounded-tl-[64px] rounded-br-[64px] object-cover'
            style={{ top: 40, left: 90, width: 480, height: 430 }}
          />

          <img
            src={fileUploadCard}
            alt=''
            className='absolute bg-white rounded-xl'
            style={{ top: 25, left: 310, width: 302, height: 96 }}
          />

          <img
            src={certificate}
            alt=''
            className='absolute'
            style={{ top: 360, left: 24, width: 233, height: 163 }}
          />

          <h1
            className='absolute m-0 text-display-md font-bold text-gray-700'
            style={{ top: 552, left: 60, width: 500 }}
          >
            Not just volunteer work— career-defining experience.
          </h1>
        </div>
      </div>
    </section>
  );
};
